import { useEffect, useState } from 'react';
import { IProject } from '../../models/IProject';
import { columns, tableConfig } from './projectsTableConfig';
import { store } from '../../store/store';
import { ROUTES, getRouteByPath } from '../../app/routes';
import { t } from '../../translations/i18n';
import { useNavigate } from 'react-router-dom';
import MikeTable from '../../shared-components/mike-table';

type IProjectsTableProps = {
  filter: string;
  projectList: Array<IProject>;
  projectListLoading: boolean;
  projectListLoadingFailed?: boolean;
};

/**
 * @name MmgProjectsTable
 * @param props
 * @summary Table rendering the list of projects
 *
 */
const MmgProjectsTable = (props: IProjectsTableProps) => {
  const { filter, projectList, projectListLoading } = props;
  const navigate = useNavigate();
  const [filteredRows, setFilteredRows] = useState([]);
  useEffect(
    () => {
      if (filter === '') {
        setFilteredRows(projectList);
      }
      const filterRows: Array<IProject> = [];
      for (const row of projectList) {
        let contains = false;
        for (const col of columns) {
          if (contains || !col.filtrable) {
            break;
          }
          contains = false;
          const objValues: Array<string> = Object.values(row);
          for (const value of objValues) {
            if (
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(filter.toLowerCase())
            ) {
              filterRows.push(row);
              contains = true;
              break;
            }
          }
        }
      }
      setFilteredRows(filterRows);
    },
    [filter, projectList],
  );

  const handleProjectSelect = (project: IProject) => {
    if (project.capabilities && project.capabilities.canReadContent) {
      const workspaceListRoute = getRouteByPath(ROUTES.workspaceList.path, {
        projectId: project.id,
      });

      navigate(workspaceListRoute);
    } else {
      store.dispatch({
        type: 'toast/ADD/NOTICE',
        toast: { text: t('PROJECTS_NO_ACCESS') },
      });
    }
  };

  return (
    <MikeTable
      rows={filteredRows}
      config={tableConfig}
      loading={projectListLoading}
      columns={columns}
      onSelect={handleProjectSelect}
    />
  );
};

export default MmgProjectsTable;
